import { lazy, Suspense, useEffect, useState } from 'react';

// Lazy load analytics components - they load as a separate chunk
const TrackingScripts = lazy(() =>
  import('@/components/seo/TrackingScripts').then(m => ({ default: m.TrackingScripts }))
);
const VisitorTracking = lazy(() =>
  import('@/components/seo/VisitorTracking').then(m => ({ default: m.VisitorTracking }))
);

/**
 * DeferredAnalytics - Loads analytics components after browser is idle
 * This ensures analytics don't block the critical rendering path
 */
export function DeferredAnalytics() {
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    // Wait for idle time before loading analytics
    if ('requestIdleCallback' in window) {
      const id = (window as any).requestIdleCallback(
        () => setShouldLoad(true),
        { timeout: 3000 }
      );
      return () => (window as any).cancelIdleCallback(id);
    } else {
      // Fallback for Safari
      const timeout = setTimeout(() => setShouldLoad(true), 2000);
      return () => clearTimeout(timeout);
    }
  }, []);

  if (!shouldLoad) return null;

  return (
    <Suspense fallback={null}>
      <TrackingScripts />
      <VisitorTracking />
    </Suspense>
  );
}

export default DeferredAnalytics;
